import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged as onAuthStateChangedModular,
} from 'firebase/auth';
import { auth } from './firebase';

const hasCustomClaims = (claims) => claims && claims['accessRoutePlanner'];

export const onAuthStateChanged = (fn) =>
  onAuthStateChangedModular(auth, async (user) => {
    if (user) {
      const token = await user.getIdTokenResult();
      fn(
        hasCustomClaims(token.claims)
          ? {
              ...user,
              uid: token.claims?.uid || user.uid,
            }
          : null
      );
    } else {
      fn(null);
    }
  });

export const getAuthToken = async () => auth.currentUser.getIdToken();

export const getUserId = async () => {
  const tokenResult = await auth.currentUser.getIdTokenResult();
  return tokenResult.claims?.uid || auth.currentUser.uid;
};

export const login = async () => {
  try {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'consent',
    });
    const result = await signInWithPopup(auth, provider);
    const tokenResult = await result.user.getIdTokenResult();
    if (!hasCustomClaims(tokenResult.claims)) {
      await logout();
      throw new Error('permission denied');
    }
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Login failed:', error);
    return false;
  }
};

export const logout = () => signOut(auth);
